"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Hitagi_Plugin_Chat {
    constructor(HitagiInstance) {
        this.OnListEvents = [];
        this.OnErrorEvents = [];
        this.OnMessageEvents = [];
        this.OnPmAccessEvents = [];
        this.hitagi = HitagiInstance;
    }
    //====================================================================
    // Plugin Chat API
    //====================================================================
    post_message(Message, Success, Error) {
        const Args = {};
        if (typeof (Message) == "string") {
            Args.message = Message;
        }
        else {
            Args.message = Message.message;
            Args.style = Message.style;
            Args.roomid = Message.roomid;
        }
        this.hitagi.log("Sending Message");
        const Packet = {
            "plugin": "chat",
            "action": "message",
            "args": Args
        };
        this.hitagi.send(Packet, Success, Error);
    }
    post_im_message(Message, To, Success, Error) {
        this.post_pm_message(Message, To, Success, Error);
    }
    post_pm_message(Message, To, Success, Error) {
        this.hitagi.im.post_message(Message, To, Success, Error);
    }
    request_pm_access(To, Success, Error) {
        this.hitagi.im.access_request(To, Success, Error);
    }
    pm_access_allow(To) {
        this.hitagi.im.access_allow(To);
    }
    pm_access_deny(To) {
        this.hitagi.im.access_deny(To);
    }
    create_room(RoomId, Success, Error) {
        this.hitagi.room.create_room(RoomId, Success, Error);
    }
    destroy_room(RoomId, Success, Error) {
        this.hitagi.room.destroy_room(RoomId, Success, Error);
    }
    //====================================================================
    // Plugin Chat events
    //====================================================================
    on_list(Func) {
        this.hitagi.on("chat:list", Func);
    }
    on_message(Func) {
        this.OnMessageEvents.push(Func);
    }
    on_pm_message(Func) {
        this.hitagi.im.on_message(Func);
    }
    on_im_message(Func) {
        this.on_pm_message(Func);
    }
    on_pm_access_request(Func) {
        this.hitagi.im.on_access_request(Func);
        //this.OnPmAccessRequestEvents.push(Func);
    }
    on_pm_access(Func) {
        this.hitagi.im.on_access_changed(Func);
        this.OnPmAccessEvents.push(Func);
    }
    on_error(Func) {
        this.OnErrorEvents.push(Func);
    }
    //====================================================================
    // Plugin Chat server callbacks
    //====================================================================
    callback__list(List) {
        this.hitagi.fire_event("chat:list", List);
    }
    callback__service_message(Args) {
        this.hitagi.fire_event("service_message", Args);
    }
    callback__message(Message) {
        this.hitagi.call_event(this.OnMessageEvents, Message);
    }
    callback__last_message(Message) {
        this.hitagi.call_event(this.OnMessageEvents, Message);
    }
    callback__room_destroyed(Args) {
        this.hitagi.fire_event("room_destroyed", Args);
    }
    callback__rooms_list(Args) {
        this.hitagi.fire_event("rooms_list", Args);
    }
    callback__client_login(Args) {
        this.hitagi.fire_event("room:client_login", Args);
    }
    callback__client_logout(Args) {
        this.hitagi.fire_event("room:client_logout", Args);
    }
    callback__client_update(Args) {
        this.hitagi.fire_event("room:client_update", Args);
    }
}
exports.default = Hitagi_Plugin_Chat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/hitagi-js/build/hitagi_plugin_chat.js
// module id = ./node_modules/hitagi-js/build/hitagi_plugin_chat.js
// module chunks = main